// src/createBasicMarksPlugin.ts
import { createPluginFactory as createPluginFactory8 } from "@udecode/plate-common";

// src/createBoldPlugin.ts
import {
  createPluginFactory,
  onKeyDownToggleMark,
  someHtmlElement
} from "@udecode/plate-common";
var MARK_BOLD = "bold";
var createBoldPlugin = createPluginFactory({
  key: MARK_BOLD,
  isLeaf: true,
  deserializeHtml: {
    rules: [
      { validNodeName: ["STRONG", "B"] },
      {
        validStyle: {
          fontWeight: ["600", "700", "bold"]
        }
      }
    ],
    query: (el) => !someHtmlElement(el, (node) => node.style.fontWeight === "normal")
  },
  handlers: {
    onKeyDown: onKeyDownToggleMark
  },
  options: {
    hotkey: "mod+b"
  }
});

// src/createCodePlugin.ts
import {
  createPluginFactory as createPluginFactory2,
  findHtmlParentElement,
  onKeyDownToggleMark as onKeyDownToggleMark2
} from "@udecode/plate-common";
var MARK_CODE = "code";
var createCodePlugin = createPluginFactory2({
  key: MARK_CODE,
  isLeaf: true,
  deserializeHtml: {
    rules: [
      {
        validNodeName: ["CODE"]
      },
      {
        validStyle: {
          fontFamily: "Consolas"
        }
      }
    ],
    query(el) {
      const blockAbove = findHtmlParentElement(el, "P");
      if ((blockAbove == null ? void 0 : blockAbove.style.fontFamily) === "Consolas")
        return false;
      return !findHtmlParentElement(el, "PRE");
    }
  },
  handlers: {
    onKeyDown: onKeyDownToggleMark2
  },
  options: {
    hotkey: "mod+e"
  }
});

// src/createItalicPlugin.ts
import {
  createPluginFactory as createPluginFactory3,
  onKeyDownToggleMark as onKeyDownToggleMark3,
  someHtmlElement as someHtmlElement2
} from "@udecode/plate-common";
var MARK_ITALIC = "italic";
var createItalicPlugin = createPluginFactory3({
  key: MARK_ITALIC,
  isLeaf: true,
  handlers: {
    onKeyDown: onKeyDownToggleMark3
  },
  options: {
    hotkey: "mod+i"
  },
  deserializeHtml: {
    rules: [
      { validNodeName: ["EM", "I"] },
      {
        validStyle: {
          fontStyle: "italic"
        }
      }
    ],
    query: (el) => !someHtmlElement2(el, (node) => node.style.fontStyle === "normal")
  }
});

// src/createStrikethroughPlugin.ts
import {
  createPluginFactory as createPluginFactory4,
  onKeyDownToggleMark as onKeyDownToggleMark4,
  someHtmlElement as someHtmlElement3
} from "@udecode/plate-common";
var MARK_STRIKETHROUGH = "strikethrough";
var createStrikethroughPlugin = createPluginFactory4({
  key: MARK_STRIKETHROUGH,
  isLeaf: true,
  handlers: {
    onKeyDown: onKeyDownToggleMark4
  },
  options: {
    hotkey: "mod+shift+x"
  },
  deserializeHtml: {
    rules: [
      { validNodeName: ["S", "DEL", "STRIKE"] },
      {
        validStyle: {
          textDecoration: "line-through"
        }
      }
    ],
    query: (el) => !someHtmlElement3(el, (node) => node.style.textDecoration === "none")
  }
});

// src/createSubscriptPlugin.ts
import {
  createPluginFactory as createPluginFactory5,
  onKeyDownToggleMark as onKeyDownToggleMark5
} from "@udecode/plate-common";
var MARK_SUBSCRIPT = "subscript";
var MARK_SUPERSCRIPT = "superscript";
var createSubscriptPlugin = createPluginFactory5({
  key: MARK_SUBSCRIPT,
  isLeaf: true,
  handlers: {
    onKeyDown: onKeyDownToggleMark5
  },
  options: {
    hotkey: "mod+,",
    clear: MARK_SUPERSCRIPT
  },
  deserializeHtml: {
    rules: [
      { validNodeName: ["SUB"] },
      {
        validStyle: {
          verticalAlign: "sub"
        }
      }
    ]
  }
});

// src/createSuperscriptPlugin.ts
import {
  createPluginFactory as createPluginFactory6,
  onKeyDownToggleMark as onKeyDownToggleMark6
} from "@udecode/plate-common";
var MARK_SUPERSCRIPT2 = "superscript";
var MARK_SUBSCRIPT2 = "subscript";
var createSuperscriptPlugin = createPluginFactory6({
  key: MARK_SUPERSCRIPT2,
  isLeaf: true,
  handlers: {
    onKeyDown: onKeyDownToggleMark6
  },
  options: {
    hotkey: "mod+.",
    clear: MARK_SUBSCRIPT2
  },
  deserializeHtml: {
    rules: [
      { validNodeName: ["SUP"] },
      {
        validStyle: {
          verticalAlign: "super"
        }
      }
    ]
  }
});

// src/createUnderlinePlugin.ts
import {
  createPluginFactory as createPluginFactory7,
  onKeyDownToggleMark as onKeyDownToggleMark7,
  someHtmlElement as someHtmlElement4
} from "@udecode/plate-common";
var MARK_UNDERLINE = "underline";
var createUnderlinePlugin = createPluginFactory7({
  key: MARK_UNDERLINE,
  isLeaf: true,
  handlers: {
    onKeyDown: onKeyDownToggleMark7
  },
  options: {
    hotkey: "mod+u"
  },
  deserializeHtml: {
    rules: [
      {
        validNodeName: ["U"]
      },
      {
        validStyle: {
          textDecoration: ["underline"]
        }
      }
    ],
    query: (el) => !someHtmlElement4(el, (node) => node.style.textDecoration === "none")
  }
});

// src/createBasicMarksPlugin.ts
var createBasicMarksPlugin = createPluginFactory8({
  key: "basicMarks",
  plugins: [
    createBoldPlugin(),
    createCodePlugin(),
    createItalicPlugin(),
    createStrikethroughPlugin(),
    createSubscriptPlugin(),
    createSuperscriptPlugin(),
    createUnderlinePlugin()
  ]
});
export {
  MARK_BOLD,
  MARK_CODE,
  MARK_ITALIC,
  MARK_STRIKETHROUGH,
  MARK_SUBSCRIPT,
  MARK_SUPERSCRIPT2 as MARK_SUPERSCRIPT,
  MARK_UNDERLINE,
  createBasicMarksPlugin,
  createBoldPlugin,
  createCodePlugin,
  createItalicPlugin,
  createStrikethroughPlugin,
  createSubscriptPlugin,
  createSuperscriptPlugin,
  createUnderlinePlugin
};
//# sourceMappingURL=index.mjs.map